import { requestApi } from "../axios";

export function getNotifications(limit, offset, type) {
  return requestApi(`/admin/notification?limit=${limit}&offset=${offset}&type=${type}`, "GET");
}

export function readNotification(payload) {
  return requestApi(`/admin/notification/read-noti`, "POST", payload);
}

export function countUnread() {
  return requestApi(`/admin/notification/count-unread`, "GET");
}
